export const engagementPresetLandingPageTemplatesData = "/engagement/preset_landing_page_templates_data";
